import { AppAction } from './../app.types';
export interface IIndexState {
	history: Breadcrumb[];
}

export type Breadcrumb = {
	type: PageType;
	id: string;
	name: string;
};

export enum PageType {
	Index,
	Chapter,
	Region,
	Theme
}

export type IndexActions = IndexAction | IndexPageAction;
export type IndexAction = AppAction<Breadcrumb>;
export type IndexPageAction = AppAction<string>;
